import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer
      className="w-full mt-auto py-6 px-4 text-xs text-slate-400 border-t border-white/5 bg-slate-950/50 relative z-10"
      style={{ paddingBottom: "calc(1.5rem + env(safe-area-inset-bottom))" }}
    >
      <div className="max-w-full">
        <div className="text-center mb-2">
          Brought to you by{" "}
          <a
            href="https://www.barklinestudio.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-white hover:text-orange-400 transition"
          >
            Bark Line Studio
          </a>
        </div>
        <div className="text-center">© {currentYear} Bark Line Studio. All rights reserved.</div>
      </div>
    </footer>
  );
}
